export default "__VITE_ASSET__d0u8sgad__"